/**
 * 固定 60Hz 逻辑步 + 渲染插值。
 * - 逻辑步内不得调用渲染或任何异步 API；
 * - hitstop 期间不累加时钟、不推进逻辑，仅渲染冻结画面。
 */

export const STEP = 1 / 60;
const MAX_FRAME_DT = 0.1; // 切后台回来的钳制

export interface LoopHooks {
  /** 推进一个逻辑步（1/60s）。 */
  step(): void;
  /** 渲染，alpha ∈ [0,1) 为本帧在两个逻辑步之间的插值系数。 */
  render(alpha: number): void;
  isFrozen(): boolean;
  consumeFreeze(dtSeconds: number): void;
}

export function startLoop(hooks: LoopHooks): () => void {
  let raf = 0;
  let last = performance.now();
  let acc = 0;

  function frame(now: number): void {
    raf = requestAnimationFrame(frame);
    let dt = (now - last) / 1000;
    last = now;
    if (dt > MAX_FRAME_DT) dt = MAX_FRAME_DT;

    if (hooks.isFrozen()) {
      hooks.consumeFreeze(dt);
      hooks.render(acc / STEP);
      return;
    }

    acc += dt;
    while (acc >= STEP) {
      hooks.step();
      acc -= STEP;
    }
    hooks.render(acc / STEP);
  }

  raf = requestAnimationFrame(frame);
  return () => cancelAnimationFrame(raf);
}
